import { Backdrop, CircularProgress, Typography } from "@mui/material";


const Loader = ({ open, message = "Please wait..." }) => (
  <Backdrop
    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1, flexDirection: "column" }}
    open={Boolean(open)}
  >
    <CircularProgress color="inherit" />
    {message && (
      <Typography variant="body2" sx={{ mt: 1.5 }}>
        {message}
      </Typography>
    )}
  </Backdrop>
);

export default Loader;
